import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../_core/_services/api.service';
import { NotificationService } from '../../_core/_services/notification.service';
import { AdminComplianceFlagListItemDto } from '../../_core/_model/compliance';

@Component({
  selector: 'app-compliance-flags',
  standalone: false,
  templateUrl: './compliance-flags.html',
  styleUrl: './compliance-flags.css'
})
export class ComplianceFlags implements OnInit {
  loading = false;
  flags: AdminComplianceFlagListItemDto[] = [];

  constructor(
    private api: ApiService,
    private notify: NotificationService
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load() {
    this.loading = true;

    this.api.getOpenComplianceFlags().subscribe({
      next: (res) => {
        this.flags = res.data || [];
      },
      error: (err) => {
        this.notify.showError(err?.error?.message || 'Failed to load compliance flags', 'Error');
      },
      complete: () => this.loading = false
    });
  }

  resolve(flag: AdminComplianceFlagListItemDto) {
    const notes = prompt('Enter resolution note');
    if (!notes?.trim()) return;

    this.api.resolveComplianceFlag(flag.id, { notes: notes.trim() }).subscribe({
      next: () => {
        this.notify.showSuccess('Compliance flag resolved successfully', 'Success');
        this.load();
      },
      error: (err) => {
        this.notify.showError(err?.error?.message || 'Failed to resolve compliance flag', 'Error');
      }
    });
  }

  getRiskBadgeClass(level: number): string {
    if (level >= 90) return 'text-bg-danger';
    if (level >= 70) return 'text-bg-warning';
    if (level >= 40) return 'text-bg-info';
    return 'text-bg-secondary';
  }
}